/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptions } from './FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptions';
import {
    instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptions,
    FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsFromJSON,
    FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsFromJSONTyped,
    FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsToJSON,
} from './FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptions';

/**
 * @type FxIdWebFeaturesPlayGameResponseStatistics
 * 
 * @export
 */
export type FxIdWebFeaturesPlayGameResponseStatistics = FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptions;

export function FxIdWebFeaturesPlayGameResponseStatisticsFromJSON(json: any): FxIdWebFeaturesPlayGameResponseStatistics {
    return FxIdWebFeaturesPlayGameResponseStatisticsFromJSONTyped(json, false);
}

export function FxIdWebFeaturesPlayGameResponseStatisticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesPlayGameResponseStatistics {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptions(json)) {
        return FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdWebFeaturesPlayGameResponseStatisticsToJSON(json: any): any {
    return FxIdWebFeaturesPlayGameResponseStatisticsToJSONTyped(json, false);
}

export function FxIdWebFeaturesPlayGameResponseStatisticsToJSONTyped(value?: FxIdWebFeaturesPlayGameResponseStatistics | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptions(value)) {
        return FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsToJSON(value as FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptions);
    }

    return {};
}

